import styled from "styled-components/macro";

export default styled.div({
  width: "100vw",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});
